import React from "react"
import { Container } from "@bw/bits"
import styled from "styled-components"
import PropTypes from "prop-types"
import { breakpoints } from "../../../theme"
import Crps from "../footer/CRPS"
import Vd from "../footer/VD"
import Police from "../footer/votre_police.png"

const StyledFooter = styled.div`
  background: var(--primary);
  clip-path: polygon(0 60px, 100% 20px, 100% 100%, 0% 100%);
  padding: 70px 0 45px 0;

  @media (min-width: ${breakpoints.medium}px) {
    padding: 130px 0 45px 0;
    clip-path: polygon(0 80px, 100% 20px, 100% 100%, 0% 100%);
  }
`

const Grid = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 1.8;
  color: #000000;
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-gap: 25px;

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 60px 125px 175px;
    width: 440px;
    margin: auto;
  }

  .vd {
    border-right: 1px solid black;
    padding-right: 25px;
    margin-right: 25px;

    @media (min-width: ${breakpoints.medium}px) {
      justify-self: end;
    }
  }

  .police {
    grid-column: 1 / 3;

    @media (min-width: ${breakpoints.medium}px) {
      transform: translateY(-15px);
      grid-column: unset;
    }
  }
`

const Footer = () => (
  <StyledFooter>
    <Container>
      <Grid>
        <div className="vd">
          <Vd />
        </div>
        <div className="crps">
          <Crps />
        </div>
        <div className="police">
          <img loading="lazy" alt="Votre police" height="50" src={Police} />
        </div>
      </Grid>
    </Container>
  </StyledFooter>
)

export { Footer }

Footer.propTypes = {
  name: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  mail: PropTypes.string,
  phone: PropTypes.string,
  mobile: PropTypes.string,
  copyright: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
}
